import { connect } from 'react-redux';
import { Container } from './Modal';
import * as selectDetail from '@app/src/views/CipReport/report/state/detail/selectors';
import * as selectModal from '@app/src/commons/modal/state/modals/selectors';
import { closeModal } from '@app/src/commons/modal/state/modals/actions';

const mapStateToProps = state => ({
  openModal: selectModal.getState(state),
  item: selectDetail.getSelectedItem(state)
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal()),
});

export const ModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
